// context/SocketContext.js
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";

const SocketContext = createContext(null);
const isLocalhost = window.location.hostname === "localhost";
export const SocketProvider = ({ tgId, children }) => {
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (!tgId) return;
    if (socketRef.current) {
      console.log("⚠️ Socket already exists, skipping");
      return;
    }
    const socketInstance = io(
      isLocalhost ? "http://localhost:1337" : "https://api.meduzya.ru",
      {
        transports: ["websocket"],
        auth: {
          initData: window.Telegram.WebApp.initData, // реальное с TG
        },
      }
    );
    console.log("Sending initData to server:", window.Telegram.WebApp.initData);
    socketRef.current = socketInstance;

    socketInstance.on("connect", () => {
      console.log("🔌 Socket connected");
      setIsConnected(true);
    });

    socketInstance.on("disconnect", () => {
      console.log("⚡️ Socket disconnected");
      setIsConnected(false);
    });

    return () => {
      socketInstance.disconnect();
    };
  }, [tgId]);

  const emit = (event, data, callback) => {
    if (socketRef.current) {
      socketRef.current.emit(event, data, callback);
    }
  };

  const on = (event, callback) => {
    if (socketRef.current) {
      socketRef.current.on(event, callback);
    }
  };

  const off = (event, callback) => {
    if (socketRef.current) {
      socketRef.current.off(event, callback);
    }
  };

  const once = (event, callback) => {
    if (socketRef.current) {
      socketRef.current.once(event, callback);
    }
  };

  return (
    <SocketContext.Provider
      value={{ socket: socketRef.current, emit, on, off, once, isConnected }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
